export let fullWindowHeightMixinBlock = {
	initFullWindowHeight: (self) => {
		self.$element = self.$element || $(self.element);

		if(!_.isNil(self.$element.data('fullscreen')) && self.$element.data('fullscreen')) {
			let setElementHeight = () => {
				let $tplHeader = $('.tpl-header');

				// Slight delay
				setTimeout(() => {
					self.$element.css({
						minHeight: `${$(window).height() - $tplHeader.height()}px`,
						visibility: 'visible'
					});
				}, 250);
			};

			$(window).resize(_.debounce(() => {
				setElementHeight();
			}, 250));

			setElementHeight();
		}
		else {
			// Slight delay
			setTimeout(() => {
				self.$element.css({
					visibility: 'visible'
				});
			}, 250);
		}
	}
};
